---
pageId: feature-quick-add
title: Logging entries quickly
description: The quick-add drawer is the fastest public v0 way to record an entry in Samlla from anywhere in the app.
category: features
order: 1
lang: en
slug: features/quick-add
updated: 2026-10-25
---

Recording should cost seconds, not attention. The quick-add drawer is available from across the app and keeps the same predictable review-and-save flow everywhere.

The AI bar requires separate consent enabled on the card shown on first use; you can later turn it off in **Settings → Privacy**.

## The quick-add drawer

The drawer opens from many places — the **Add Entry** button in the top bar (desktop), the **+** button (phone), the plus that appears when you hover a timeline row (pre-filled with that tracker and time), or any empty day. Wherever you trigger it, the flow is the same:

1. **Choose the mode**: **Entry** for a metric entry, **Note** for a free-form journal note.
2. **Pick a tracker** — search by name, or take one from the top section, which surfaces trackers scheduled for today ordered by urgency. Press Enter to take the top match. Each row shows the last recorded value, so you have context before you type.
3. **Fill the form**: date and time with one-tap offsets (**Now**, -15m, -1h, -1d), a typed input per metric, optional tags and notes.
4. **Save** with **Create Entry** — or switch the button to **Save & Add Next** when you are logging several things in a row. The preference sticks.

Below the form you see the tracker's recent entries, so a duplicate or a typo is easy to catch before it happens.

## Drafts that survive

Everything you type is snapshotted as a draft, kept separately per tracker. Close the drawer mid-entry, come back later — the title shows "draft" and your values are restored. **Clear** wipes the draft when you want a clean start.

## Quick notes

Note mode lists only your journal-mode trackers and asks a single question: what happened? If you keep one journal tracker, it is selected automatically — open, type, save.

## Editing and deleting

Hover an entry in the Journal and use the pencil to edit — the same drawer opens in edit mode with **Update Entry** and **Delete Entry** actions. Deleting always asks for confirmation; it cannot be undone.
